import { motion } from "framer-motion";
import { SectionReveal, ChapterHeading } from "./Shared";
import { useLang } from "../../i18n";

const POSITIONS = [
  "left-[2%] top-[200px] w-[30%]",
  "left-[35%] top-0 w-[30%]",
  "left-[68%] top-[200px] w-[30%]",
];

const WaveGroup = ({ title, desc, testid }) => (
  <div className="text-center" data-testid={testid}>
    <h3 className="font-display text-2xl font-bold text-[#C9B0FF] sm:text-3xl">{title}</h3>
    <p className="mx-auto mt-4 max-w-sm text-base leading-relaxed text-black">{desc}</p>
  </div>
);

export default function ValueCards() {
  const { t } = useLang();
  const GROUPS = t.value.groups.map((g, i) => ({ ...g, pos: POSITIONS[i] }));
  return (
    <section id="neden" className="border-y border-[#9B7AE8]/15 bg-white py-28" data-testid="value-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterHeading
          index="04"
          label={t.value.label}
          title={t.value.title}
          sub={t.value.sub}
        />

        <SectionReveal className="mt-8 hidden md:block">
          <div className="relative h-[420px]" data-testid="value-wave">
            <svg
              viewBox="0 0 1200 300"
              preserveAspectRatio="none"
              className="absolute inset-x-0 top-[30px] h-[300px] w-full"
              fill="none"
              aria-hidden="true"
            >
              <motion.path
                d="M0 155 C 130 45, 260 45, 400 155 C 540 265, 660 265, 800 155 C 940 45, 1070 45, 1200 155"
                stroke="#C9B0FF"
                strokeWidth="1.5"
                initial={{ pathLength: 0 }}
                whileInView={{ pathLength: 1 }}
                viewport={{ once: true, margin: "-120px" }}
                transition={{ duration: 2.2, ease: "easeInOut" }}
              />
            </svg>
            {GROUPS.map((g, i) => (
              <div key={g.title} className={`absolute ${g.pos}`}>
                <WaveGroup title={g.title} desc={g.desc} testid={`value-card-${i}`} />
              </div>
            ))}
          </div>
        </SectionReveal>

        <div className="mt-14 space-y-14 md:hidden" data-testid="value-wave-mobile">
          {GROUPS.map((g, i) => (
            <SectionReveal key={g.title} delay={0.05 + i * 0.08}>
              <WaveGroup title={g.title} desc={g.desc} testid={`value-card-mobile-${i}`} />
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
